import styled from 'styled-components';
import { Common } from '@stockbit/ui';

export const Container = styled.div`
  padding: 20px;
`;

export const BorderedWrapper = styled.div`
  border: 1px solid #ededed;
  border-radius: 4px;
  padding: 16px 20px;
  margin: 16px 20px;
  gap: 16px;
  width: 335px;
`;

export const Section = styled.section`
  padding: 0px;
  padding-bottom: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const ConfirmButton = styled(Common.Button)`
  :disabled {
    background: #616161 !important;
    color: #cbcbcb;
    border: none;
  }
`;
